import React from 'react'
import { Input } from 'components/fields'

const SocialLinks = () => (
  <div>
    <Input label="Website" intlKey="label.website" name="website" />
    <Input label="Facebook" intlKey="label.facebook" name="facebook" />
    <Input label="Twitter" intlKey="label.twitter" name="twitter" />
    <Input label="Youtube" intlKey="label.youtube" name="youtube" />
  </div>
)

export default SocialLinks
